module.exports = __webpack_public_path__ + "img/flowers1.9f5a7cac.jpg";